/* @ngInject */
function SocialMediaIntegrationBannerController ($rootScope, $scope, $translate, $window, $location, LocalStorageService, SocialMediaService, ToastService) {
  $scope.flags = {
    show: false
  }

  $scope.type = 'LATER_INTEGRATION'

  $scope.message = ''
  $scope.buttonText = ''

  let socialMediaIntegration = null

  const api = {
    _setIntegrationTexts,
    _isIntegrationLater,
    _getSocialMediaInfo,
    _showDefaultError,
    _showBanner,
    _checkSocialMediaStatus,
    _removeEntireStorage
  }

  this.getApi = () => api

  activate()
  function activate () {
    const accounts = $rootScope.oUser?.socialAccounts || []

    const expiredAccounts = SocialMediaService.getSocialAccountsExpired(accounts)
    const hasExpiredAccounts = expiredAccounts.length
    const hasNotAccounts = accounts.length

    if (hasExpiredAccounts || hasNotAccounts) {
      api._getSocialMediaInfo()
    }

    api._checkSocialMediaStatus()
  }

  function _setIntegrationTexts (type) {
    const types = {
      LATER_INTEGRATION: {
        message: $translate.instant('socialMedia.integrationBanner.later.message'),
        buttonText: $translate.instant('socialMedia.integrationBanner.later.buttonText')
      },
      FINALIZE_INTEGRATION: {
        message: $translate.instant('socialMedia.integrationBanner.finalize.message'),
        buttonText: $translate.instant('socialMedia.integrationBanner.finalize.buttonText')
      }
    }

    const { message, buttonText } = types[String(type)] || types.LATER_INTEGRATION

    $scope.message = message
    $scope.buttonText = buttonText
  }

  $scope.handleIntegrate = () => {
    const url = socialMediaIntegration?.url

    if (url) {
      LocalStorageService.set('socialMedia.integrateAttempt', true)
      $window.open(url, '_self')
    }
  }

  $scope.onClose = (event) => {
    $scope.flags.show = false
    LocalStorageService.set('socialMedia.integrateBannerHide', true)
    api._removeEntireStorage()
  }

  function _isIntegrationLater () {
    const integrationStorageValue = parseInt(LocalStorageService.get('socialMedia.integrateLater'), 10)

    if (!integrationStorageValue) {
      return false
    }

    const laterTime = new Date(integrationStorageValue).getTime()
    const currentTime = new Date().getTime()

    return currentTime > laterTime
  }

  async function _getSocialMediaInfo () {
    try {
      const gatewayResponse = await $rootScope.getSocialMediaGateway()
      const isEnableSocialMedia = await $rootScope.getEnableSocialMedia(true)

      socialMediaIntegration = gatewayResponse

      api._showBanner(isEnableSocialMedia)
    } catch (error) {
      api._showDefaultError(error)
    }
  }

  function _showDefaultError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  async function _showBanner (isEnableSocialMedia) {
    $scope.flags.show = false

    if (!isEnableSocialMedia) {
      return
    }

    const isIntegrationLater = api._isIntegrationLater()
    const isNotBannerHide = !LocalStorageService.get('socialMedia.integrateBannerHide')
    const hasIntegrateAttempt = LocalStorageService.get('socialMedia.integrateAttempt')

    if (hasIntegrateAttempt && isNotBannerHide) {
      $scope.flags.show = true
      api._setIntegrationTexts('FINALIZE_INTEGRATION')
      return
    }

    if (isIntegrationLater && isNotBannerHide) {
      $scope.flags.show = true
      api._setIntegrationTexts('LATER_INTEGRATION')
    }
  }

  function _checkSocialMediaStatus () {
    const status = $location.search()?.socialMediaStatus

    if (status === 'SUCCESS') {
      $scope.flags.show = false
      api._removeEntireStorage()
    }
  }

  function _removeEntireStorage () {
    LocalStorageService.del('socialMedia.expiryModalHide')
    LocalStorageService.del('socialMedia.integrateLater')
    LocalStorageService.del('socialMedia.integrateAttempt')
  }
}

export { SocialMediaIntegrationBannerController }
